<template>
  <div class="medicine">
    <el-row justify="center" class="medicine-titles mt-5">
      <el-col align="center">
        <h3>Radiologia</h3>
        <h4>RIS + PACS</h4>
      </el-col>
    </el-row>

    <el-row justify="center" class="medicine-titles mt-5">
      <el-col align="center">
        <figure>
          <img
            class="icon"
            alt="Vue logo"
            :src="data.medic.img1"
          />
        </figure>
      </el-col>
    </el-row>

    <el-row justify="center" class="medicine-titles mt-5">
      <el-col align="center">
        <h4>Pixeon Korus</h4>
        <p>
          Todo o nosso <strong>conhecimento e experiência em diagnostico por imagem</strong> à sua disposição
          para <strong>maior produtividade</strong> e  <strong>mais eficiência</strong> em gestão.
        </p>
      </el-col>
    </el-row>

    <el-row justify="center" class="medicine-titles mt-5">
      <el-col align="center">
        <figure>
          <img
            class="icon"
            alt="Vue logo"
            :src="data.medic.img2"
          />
        </figure>
      </el-col>
    </el-row>

    <el-row justify="center" class="medicine-titles mt-5">
      <el-col align="center">
        <figure>
          <img
            class="icon"
            alt="Vue logo"
            :src="data.medic.img3"
          />
        </figure>
      </el-col>
    </el-row>

    <el-row justify="center" class="medicine-titles mt-5">
      <el-col align="center">
        <h4>Pixeon Aurora</h4>
      </el-col>
    </el-row>

    <el-row justify="center" class="medicine-titles mt-5">
      <el-col align="center">
        <figure>
          <img
            class="icon"
            alt="Vue logo"
            :src="data.medic.img4"
          />
        </figure>
      </el-col>
    </el-row>

    <el-row justify="center" class="medicine-titles mt-5">
      <el-col align="center">
        <h3>Interfaceamento Laboratórios</h3>
        <h4>LIS</h4>
      </el-col>
    </el-row>

    <el-row justify="center" class="medicine-titles mt-5">
      <el-col align="center">
        <figure>
          <img
            class="icon"
            alt="Vue logo"
            :src="data.medic.img5"
          />
        </figure>
      </el-col>
    </el-row>

    <el-row justify="center" class="medicine-titles mt-5">
      <el-col align="center">
        <h4>PIXEON korus</h4>
      </el-col>
    </el-row>

    <el-row justify="center" class="medicine-titles mt-5">
      <el-col align="center">
        <figure>
          <img
            class="icon"
            alt="Vue logo"
            :src="data.medic.img6"
          />
        </figure>
      </el-col>
    </el-row>

    <el-row justify="center" class="medicine-titles mt-5">
      <el-col align="center">
        <h4>PIXEON lablink pro</h4>
      </el-col>
    </el-row>

    <el-row justify="center" class="medicine-titles mt-5">
      <el-col align="center">
        <figure>
          <img
            class="icon"
            alt="Vue logo"
            :src="data.medic.img7"
          />
        </figure>
      </el-col>
    </el-row>
    <div class="close-btn-text mt-5 mb-5" @click="$emit('close-service')">Fechar</div>
  </div>
</template>

<script>
export default {
  name: 'Medicine',
  props: ['data']
}
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";
.medicine {
  img {
    width: 100%;
  }
}

.medicine-titles {
  text-transform: uppercase;

  h3 {
    font-weight: bold;
    color: $green;
    max-width: 60%;
    font-size: 3rem;
    line-height: 4rem;
  }

  h4 {
    font-size: 3rem;
    line-height: 4rem;
    color: $green;
    font-weight: 300;
  }

  p {
    padding-top: 2rem;
    text-transform: none;
    width: 60%;
  }
}
</style>
